import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { db } from '../config/firebaseConfig';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';

const UnsubscribePage = () => {
    const [searchParams] = useSearchParams();
    const email = searchParams.get('email');
    
    const [status, setStatus] = useState('idle'); // idle, loading, success, error, invalid
    const [message, setMessage] = useState('');

    useEffect(() => {
        if (!email || !email.includes('@')) {
            setStatus('invalid');
            setMessage('Invalid or missing email address.');
        }
    }, [email]);

    const handleUnsubscribe = async () => {
        setStatus('loading');
        try {
            // OKUMA İŞLEMİNİ KALDIRDIK!
            // Doğrudan veritabanına ekleme (create) yapıyoruz. 
            // Firestore kurallarında 'create: if true' olduğu için bu işlem sorunsuz çalışacaktır.
            await addDoc(collection(db, 'unsubscribedEmails'), {
                email: email,
                unsubscribedAt: serverTimestamp()
            });
            
            setStatus('success');
            setMessage('You have successfully unsubscribed. You will no longer receive campaign emails from us.');
        } catch (error) {
            console.error("Unsubscribe error:", error);
            setStatus('error');
            setMessage('An error occurred. Please try again later.');
        }
    };

    return (
        <div className="min-vh-100 d-flex align-items-center justify-content-center bg-light">
            <div className="card shadow-sm p-4 text-center" style={{ maxWidth: '400px' }}>
                <h2 className="mb-3 text-dark">Unsubscribe</h2>
                
                {status === 'invalid' && (
                    <div className="alert alert-danger">{message}</div>
                )}

                {(status === 'idle' || status === 'loading') && status !== 'invalid' && (
                    <>
                        <p className="text-muted mb-4">
                            Are you sure you want to unsubscribe <strong>{email}</strong> from our mailing list?
                        </p>
                        <button 
                            className="btn btn-danger w-100 fw-bold" 
                            onClick={handleUnsubscribe}
                            disabled={status === 'loading'}
                        >
                            {status === 'loading' ? 'Processing...' : 'Yes, Unsubscribe Me'}
                        </button>
                    </>
                )}

                {status === 'success' && (
                    <div className="alert alert-success mt-3">
                        {message}
                    </div>
                )}

                {status === 'error' && (
                    <div className="alert alert-danger mt-3">
                        {message}
                    </div>
                )}
            </div>
        </div>
    );
};

export default UnsubscribePage;